import { useQueryUser } from '@/hooks/query/useQueryUser';

export const useDefaultInputLanguages = () => {
  const { data: languages } = useQueryUser(({ session_settings }) => {
    const list = session_settings?.default_input_language_code_list;
    if (list?.length) return list;
    const code = session_settings?.default_input_language_code;
    return code ? [code] : undefined;
  });

  return languages;
};
